

const TRANSACTIONS_PER_PAGE = 10;

module.exports = {
    TRANSACTIONS_PER_PAGE
};
